import { formatTime } from '../../helpers/formatting';

export function generateTime(time, locale) {
    return formatTime(Number(time) === 25 ? 1 : time, locale);
}
